import { usePlaygroundLocalMsg } from "@faire/prototype-playground/platform/localization";
import { FilterToggle } from "@faire/slate/components/filter";
import { tsv } from "@faire/slate/lib/tsv";

import { SlateStyleOverride } from "../../../components/shared";

/** "brands" groups the saved products under a lockup per brand. */
export type SavedViewMode = "products" | "brands";

interface ViewModeToggleProps {
  value: SavedViewMode;
  onChange: (viewMode: SavedViewMode) => void;
}

/**
 * Products / Brands segmented control: two Slate FilterToggles inside a
 * bordered pill. The override shrinks the toggles to the design's 32px and
 * hides the rest-state border so only the applied segment reads as a pill.
 */
export const ViewModeToggle = ({ value, onChange }: ViewModeToggleProps) => {
  const productsLabel = usePlaygroundLocalMsg("Products");
  const brandsLabel = usePlaygroundLocalMsg("Brands");

  return (
    <div
      role="radiogroup"
      className="border-fs-border-muted flex items-center gap-2 rounded-full border p-1"
    >
      <SlateStyleOverride className={viewModeToggleOverrideStyle.cls()}>
        <FilterToggle
          label={productsLabel}
          applied={value === "products"}
          onClick={() => onChange("products")}
        />
        <FilterToggle
          label={brandsLabel}
          applied={value === "brands"}
          onClick={() => onChange("brands")}
        />
      </SlateStyleOverride>
    </div>
  );
};

const viewModeToggleOverrideStyle = tsv({
  base: [
    "[&_.fs-filter]:[--fs-filter-height:32px]",
    "[&_.fs-filter:not(.fs-filter--applied)]:[--fs-filter-border-color:transparent]",
  ],
});
